<!-- @veltra/icons generated sha256:3ad2054e1a65727c gen:8 source:src/svg/normal/cart.svg -->
<script setup lang="ts">
defineOptions({ name: 'Cart' })
</script>
<template>
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16">
    <path
      fill="currentColor"
      d="M4.75 14.5a.75.75 0 1 0 0-1.5.75.75 0 0 0 0 1.5m8.063 0a.75.75 0 1 0 0-1.5.75.75 0 0 0 0 1.5M1.499 3h1.077l1.389 8.332a.8.8 0 0 0 .79.668h8.735c.276 0 .51-.228.51-.504a.5.5 0 0 0-.5-.496H4.924L4.59 9h8.634A.8.8 0 0 0 14 8.394l.85-3.4A.8.8 0 0 0 14.074 4H3.757l-.222-1.332A.8.8 0 0 0 2.745 2H1.499a.5.5 0 0 0 0 1m11.57 5H4.424l-.5-3h9.894z"
    />
  </svg>
</template>
